import '@angular/compiler';
import { PageMainComponent } from './page.main/page.main.component';
import { LayoutMainComponent } from './layout.main/layout.main.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { URLPattern } from 'urlpattern-polyfill';

const appRoutes: Routes = [
    {
        component: LayoutMainComponent,
        "children": [
            {
                "path": "",
                component: PageMainComponent,
                "app_id": "page.main"
            }
        ]
    }
];

export class RouteInfo {
    public path: string = '';
    public segment: Record<string, string> = {};
}

window.WizRoute = new RouteInfo();

const patternMatcher = (pattern: string, url: any[]) => {
    const path = url.map((item: any) => item.path).join('/');
    const match = new URLPattern({ pathname: `/${pattern}` }).exec(`http://wiz.local/${path}`);

    if (!match?.pathname) return null;

    const posParams: Record<string, string> = {};
    for (const key in match.pathname.groups) {
        const value = match.pathname.groups[key];
        if (value) posParams[key] = value;
    }

    window.WizRoute.path = path;
    window.WizRoute.segment = posParams;
    return { consumed: url, posParams };
};

const routes: Routes = [];

for (const layout of appRoutes) {
    routes.push({
        path: '',
        component: layout.component,
        children: layout.children.map((child: any) => ({
            matcher: (url: any[]) => patternMatcher(child.path, url),
            component: child.component
        }))
    });
}

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
